export const NAMESPACE = 'buildcards';

export const TOGGLE_BUILD_CARD = `${NAMESPACE}/TOGGLE_BUILD_CARD`;
